import * as z from 'zod';

export const CompanyLogos = z.object({
  portalLogo: z.boolean(),
  emailLogo: z.boolean(),
});
export type CompanyLogos = z.infer<typeof CompanyLogos>;
